import { HTTP_WITHOUT_HEADER, HTTP } from '../../utils'
import { LABELS } from '../../labels'

export const populatePackages = (uuid) => {
  return HTTP().get('package/allProductPackages')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getUserReports = () => {
  return HTTP().get('reports/institution')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getUserReportsByRole = (role, userUuid) => {
  return HTTP().get('reports/institution/user/' + userUuid + '/' + role)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getPackageFeatures = (packageId) => {
  return HTTP().get('package/' + packageId + '/features')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionInfo = (token, uuid) => {
  return HTTP(token).get('/institution/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionInfoPackages = (token, uuid, isAggregated) => {
  let url = '/institution/' + uuid + '/package?isAggregated='
  url += isAggregated ? 'true' : 'false'
  return HTTP(token).get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionDetails = (uuid) => {
  return HTTP().get('/institution/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getPublicInstitutionDetails = (uuid) => {
  return HTTP().get('/institution/publicInstitution/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionPackages = (uuid, isAggregated) => {
  let url = '/institution/' + uuid + '/package?isAggregated='
  url += isAggregated ? 'true' : 'false'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const createNewInstitution = (institutionData, ownerId) => {
  return HTTP().put('/institution?ownerId=' + ownerId, institutionData)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return e
  })
}

export const saveInstitution = (institutionData) => {
  return HTTP().put('/institution/' + institutionData.uuid, institutionData)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return e.response
  })
}

export const getInstitutionLabels = (openId) => {
  /*
  if (!openId) {
    openId = 'INSTITUTION_WITHOUT_OPEN_ID'
  }
  let url = 'configuration/' + openId
  return HTTP().get(url)
  .then(resp => {
    let data = resp.data
    if (data.hasOwnProperty('error')) {
      return LABELS
    }
    return data
  })
  .catch(e => {
    return e.response
  })
  */
  return new Promise((resolve, reject) => {
    resolve(LABELS)
  })
}

export const searchInstitutionsByTitle = (page, count, title) => {
  if (!page || page < 0) {
    page = 0
  }
  let url = '/institution/searchAll?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (title) {
    url = url + '&title=' + title
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const searchPreCuratedInstitutionsByName = (page, count, name) => {
  if (!page || page < 0) {
    page = 0
  }
  let url = '/precuratedInstitution/search?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (name) {
    url = url + '&name=' + name
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteInstitutionObject = (uuid) => {
  var url = '/institution/' + uuid + '/softDelete'
  return HTTP().put(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const generateWidgetKeyAndSecret = (uuid, type) => {
  return HTTP().put('/widget/generateClientId/' + uuid + '?origin=' + window.location.origin + '&type=' + type)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getWidgetDetail = (uuid, type) => {
  let url = '/widget/find/' + uuid
  if (type) {
    url += '?type=' + type
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteWidgetKeyAndSecret = (uuid) => {
  return HTTP().delete('/widget/' + uuid)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const postSaveWidgetDetails = (widget) => {
  return HTTP().post('/widget/updateWidgetIntroductionMessage', widget)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateWidgetKeyAndSecret = (widget) => {
  return HTTP().put('/widget/' + widget.uuid, widget)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getEmailCampaignList = () => {
  return HTTP().get('/emailcampaign/institution')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createEmailCampaign = (emailCampaignObj) => {
  return HTTP().put('/emailcampaign', emailCampaignObj)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const logDashboardActivity = (activity, token) => {
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return HTTP_WITHOUT_HEADER().put('entity/log?token=' + token, JSON.stringify(activity), config)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getApiConfigs = (uuid, page, count) => {
  let url = 'marketplaceApiConfig/loadConfig/' + uuid + '?page=' + page + '&count=' + count
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const generateOrEditApiConfig = (apiConfig) => {
  let url = 'marketplaceApiConfig/generate/' + apiConfig.institutionId
  if (apiConfig.uuid) {
    url = 'marketplaceApiConfig/update/' + apiConfig.uuid
  }
  return HTTP().put(url, apiConfig)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
    return e.response
  })
}

export const deleteMultipleApiConfigs = (uuids) => {
  return HTTP().delete('marketplaceApiConfig/multiple?uuids=' + uuids)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getInstitutionTermMap = (uuid, excludePastCutOff) => {
  let url = '/institution/loadTermMap/' + uuid
  if (excludePastCutOff) {
    url += '?excludePastCutOff=true'
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAllAvailableInstitutions = () => {
  return HTTP().get('institution/articulation/availableInstitutions')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getPartnerInstitutions = (includeSelf) => {
  return HTTP().get('institution/partnerInstitutions?includeSelf=' + includeSelf)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getTermsGradesAndCategoriesFromInstitution = () => {
  return HTTP().get('institution/articulationConfig/termGradeAndCategoryMap')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const doCsvUploadForPreCuratedInstitution = (data) => {
  return HTTP().post('/precuratedInstitution/csvUpload', data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deletePreCuratedInstitutionObject = (uuid) => {
  var url = '/precuratedInstitution/' + uuid
  return HTTP().delete(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getInstitutionMetaInfo = () => {
  return HTTP().get('institution/metaInfo')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const generateSelfRegistrationLink = (uuid) => {
  let origin = window.location.origin
  let url = 'institution/generateSelfRegistrationLink/' + uuid + '?origin=' + origin
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deleteSelfRegistrationLink = (uuid) => {
  return HTTP().delete('institution/deleteSelfRegistrationLink/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionMetaInfoForSelfRegistration = (uuid) => {
  return HTTP_WITHOUT_HEADER().get('institution/selfRegistrationMetaInfo/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getSelfRegistrationConfiguration = (uuid) => {
  return HTTP().get('institution/selfRegistrationConfiguration/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const updateSelfRegistrationConfiguration = (uuid, data) => {
  return HTTP().put('institution/selfRegistrationConfiguration/' + uuid, data)
  .then(response => {
    return response
  })
  .catch(e => {
    console.log('Error:' + e)
    return e.response
  })
}

export const getInstitutionPaymentGateway = () => {
  return HTTP().get('institution/paymentGatewayIntegration/STRIPE')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getStripeConnectUrl = () => {
  return HTTP().get('institution/generateStripeConnectUrl')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionProducts = () => {
  return HTTP().get('institutionProduct/all')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putCreateInstitutionProduct = (institutionProductObj) => {
  return HTTP().put('institutionProduct', institutionProductObj)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deleteInstitutionProduct = (institutionProductId) => {
  return HTTP().delete('institutionProduct/' + institutionProductId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionPricingPlans = () => {
  return HTTP().get('pricingPlan/all')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putCreateInstitutionPricingPlan = (institutionPricingPlanObj) => {
  return HTTP().put('pricingPlan', institutionPricingPlanObj)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deleteInstitutionPricingPlan = (institutionPricingPlanId) => {
  return HTTP().delete('pricingPlan/' + institutionPricingPlanId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putAssignProgramGuide = (institutionPricingPlanId, programGuides) => {
  return HTTP().put('pricingPlan/' + institutionPricingPlanId + '/assignProgramGuide', programGuides)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putDeleteAssignmentProgramGuide = (institutionPricingPlanId, programGuides) => {
  return HTTP().put('pricingPlan/' + institutionPricingPlanId + '/removeAssignmentProgramGuide', programGuides)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionTransactions = (page, count) => {
  return HTTP().get('transaction/institutionTransactions?page=' + page + '&count=' + count)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstitutionCouponCodes = () => {
  return HTTP().get('couponCode/all')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putRefundTransaction = (transactionId, refundObj) => {
  return HTTP().put('transaction/' + transactionId + '/refund', refundObj)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putCreateInstitutionCouponCode = (institutionCouponCodeObj) => {
  return HTTP().put('couponCode', institutionCouponCodeObj)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putSaveInstitutionCouponCode = (institutionCouponCodeId, institutionCouponCodeObj) => {
  return HTTP().put('couponCode/' + institutionCouponCodeId, institutionCouponCodeObj)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const downloadAnswersAsCsvFile = () => {
  let url = '/qa/download/all'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const downloadLearnerReportAsCsvFile = () => {
  let url = '/reports/download/all'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const deleteInstitutionCouponCode = (institutionCouponCodeId) => {
  return HTTP().delete('couponCode/' + institutionCouponCodeId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}



// WEBPACK FOOTER //
// ./widgetSrc/app/institution/api.js